import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import HistoryModal from './_history-modal/component';
import { Button, Icon, Badge } from 'audamatic-ui';
import store from '@utils/store';
import Restapi  from '@utils/api';
import { IS_B2B } from '@config';
import { t } from '@utils/i18n';

import './styles.scss';

const HistoryToggle = (props) => {
  const { product, size = 'medium', productHistory, isSingleProduct } = props;

  if (!IS_B2B) {
    return null;
  }

  const [history, setHistory] = useState({});

  const restapi = new Restapi();

  const fetchProductHistory = () => {
    if (isSingleProduct) {
      restapi.getProductHistory([product.ean || product.sku])
        .then((response) => {
          setHistory(response[0]);
        });
    } else {
      if (productHistory) {
        setHistory(productHistory);
      }
    }
  };

  useEffect(() => {
    fetchProductHistory();
  }, [product.sku, productHistory]);


  const { openProducts, deliveredProducts, openQuantity } = history;

  const openHistoryModal = () => {
    store.modal.openModal('sidepanel', 'right', {
      title: t('pdp.orderhistory.titel'),
      component: <HistoryModal
        product={product}
        store={store}
        openProducts={openProducts}
        deliveredProducts={deliveredProducts}
      />,
    });
  };

  const iconSize = 'large' ? 'md' : 'sm';

  // Every time the history changes we check if we need to show the button or not.
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    if (openQuantity || deliveredProducts?.length > 0) {
      setShowButton(true);
    }
  }, [history]);

  if (!showButton) {
    return null;
  }

  return (
    <div className="btn-toggle-history">
      <Button
        variant="secondary"
        size={size}
        iconLeft={<Icon name="List" size={iconSize}/>}
        onClick={openHistoryModal}
        data-test-id="button-historyToggle"
      />
      {!!openQuantity && (
        <div className="badge-container">
          <Badge number={openQuantity} size="tiny"/>
        </div>
      )}
    </div>
  );
};
HistoryToggle.propTypes = {
  product: PropTypes.object,
  size: PropTypes.string,
  productHistory: PropTypes.object,
  isSingleProduct: PropTypes.bool,
};
export default HistoryToggle;
